import { IDictionary } from '@bimser/core';
import { HorizontalAlign, MultiLanguageText } from '../../../entities/common';
import { IEditControlProperties } from '../entities/IEditControlProperties';
import EditControlBase from './EditControlBase';
import { JSX } from 'react';

export default class EditControl<TValue> extends EditControlBase<TValue> {
	placeholder: MultiLanguageText;
	textAlign: HorizontalAlign;

	constructor() {
		super();
	}

	__getMLClassPath() {
		return [...super.__getMLClassPath(), 'placeholder'];
	}

	initialize() {
		super.initialize();

		this.placeholder = new MultiLanguageText(
			(text: string, culture: string, existCultures: string[]) => {
				this.__onChangeMLTextValue(text, 'placeholder', culture, existCultures);
			}
		);
		this.textAlign = 'left';
	}

	__loadProperties(data: IEditControlProperties<TValue>) {
		super.__loadProperties(data);

		if (data.placeholder) {
			this.placeholder.setData(data.placeholder);
		}
		this.__proxyChanged.textAlign = data.textAlign;
	}

	__getComponentData(): IDictionary<any> {
		return {
			...super.__getComponentData(),
			placeholder: this.placeholder.getData(),
			textAlign: this.textAlign
		};
	}

	__render(children?: React.ReactNode): JSX.Element {
		return super.__render(children);
	}
}
